module.exports = __webpack_public_path__ + "img/uenoyama-ryuto.94f4eee6.jpg";